module.exports = __webpack_public_path__ + "img/user-dark.b36f8743.svg";